import { Component, OnInit, Input } from '@angular/core';
import { Result } from '../../../objects/result';
import { EventConfig } from '../../../objects/event-config';

@Component({
  selector: 's18-score-badge',
  templateUrl: './score-badge.component.html',
  styleUrls: ['./score-badge.component.scss']
})
export class ScoreBadgeComponent implements OnInit {
  @Input() eventResult : Result;

  config : EventConfig;

  constructor() { }

  ngOnInit() {
    if ( this.eventResult ){
      this.config = new EventConfig(this.eventResult);
    }
  }

  playing() : boolean {
    return this.config.playing() || this.config.notStarted();
  }

  completed() : boolean {
    return this.config.completed();
  }
}
